import { useContext } from 'react';

import DatasetDefinitionsContext from 'contexts/DatasetDefinitionsContext';
import programHasSubPeriods from 'contextProviders/BonusAppProvider/programHasSubPeriods';

import SignOffBoardContext from '../contexts/SignOffBoardContext';

/**
 * True only for sign-off boards of sub-period programmes. Their grid is
 * aggregated by driver across the parent sign-off period (see
 * useAggregatedBonusDatasource) rather than showing raw weekly rows. The single
 * source of truth for that branch: PerformanceBoard evaluates it once to switch
 * both the grid's datasource and its Export (ag-grid CSV download instead of the
 * search2-oriented export); the field settings use it to warn staff that columns
 * are summed across the period.
 */
const useShouldAggregateSignOff = (
  board: PerformanceBoardTypes.Board,
): boolean => {
  const { isSignOffBoard } = useContext(SignOffBoardContext);
  const { getBonusProgram } = useContext(DatasetDefinitionsContext);

  return (
    isSignOffBoard && programHasSubPeriods(getBonusProgram(board.dataType))
  );
};

export default useShouldAggregateSignOff;
